module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-16.bb1aea83.png";